export default __webpack_public_path__ + "static/media/responsible-disclosure.0444e6f2.svg";